import { textTutorialPerson } from "../constants/text-tutorial-person";
import { STEP_TUTORIAL, type StepTutorialTypes } from "../constants/tutorial";

interface TypesProps {
  playerDataTutorialStep: number;
  stepTutorial: StepTutorialTypes;
  showTutorial: (
    type: "token" | "default",
    text: JSX.Element,
    bottom?: string,
    yPosText?: string,
    yPosCloud?: string,
  ) => void;
}
export const managerTutorialStep = ({
  playerDataTutorialStep,
  stepTutorial,
  showTutorial,
}: TypesProps) => {
  if (playerDataTutorialStep === 1 && stepTutorial === STEP_TUTORIAL.INIT) {
    showTutorial(
      "token",
      textTutorialPerson.welcome,
      undefined,
      "-400px",
      "-160px",
    );
  }
  if (
    playerDataTutorialStep === 1 &&
    stepTutorial === STEP_TUTORIAL.CLICK_PLACE
  ) {
    showTutorial(
      "token",
      textTutorialPerson.selectBuilding,
      "210px",
      "-220px",
      "-60px",
    );
  }

  if (
    playerDataTutorialStep === 2 &&
    stepTutorial === STEP_TUTORIAL.SELECT_BUILDING
  ) {
    showTutorial(
      "default",
      textTutorialPerson.collectResources,
      undefined,
      "-380px",
      "-170px",
    );
  }

  if (
    playerDataTutorialStep === 3 &&
    stepTutorial === STEP_TUTORIAL.COLLECT_RESOURCES
  ) {
    showTutorial(
      "token",
      textTutorialPerson.sellResources,
      undefined,
      "-310px",
      "-130px",
    );
  }
  if (
    playerDataTutorialStep === 3 &&
    stepTutorial === STEP_TUTORIAL.OPEN_SELL
  ) {
    showTutorial(
      "token",
      textTutorialPerson.openSell,
      "250px",
      "-210px",
      "-80px",
    );
  }
  if (stepTutorial === STEP_TUTORIAL.SELL && playerDataTutorialStep === -2) {
    showTutorial("token", textTutorialPerson.endMain);
  }
};
